module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai160-25f3b371e77e33176f2f9af98465b67c.jpg";